import {useSelector, useDispatch} from 'react-redux'
import {getStudyPeriods} from '../../data/StudyPeriod/studyPeriodSlice'
import {useEffect} from 'react'
import moment from 'moment'
import LanguageFilter from './LanguageFilter'

const StudyPeriodDate = () => {
  const {studyPeriodStartDate, studyPeriodEndDate, studyPeriodNum} = useSelector((state) => state.studyPeriod)

  const formattedStartDate = moment.unix(studyPeriodStartDate).format('YYYY-MMM-DD')
  const formattedEndDate = moment.unix(studyPeriodEndDate).format('YYYY-MMM-DD')

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getStudyPeriods(formattedStartDate))
  }, [dispatch, formattedStartDate, formattedEndDate])

  return (
    <div className='study-period-date'>
      <h3 className='title'>{`${studyPeriodNum[studyPeriodNum.length - 1]}th Academy Study Period`}</h3>
      <div className='progress-container'>
        <div className='row'>
          <div className='col-4 col-lg-3'>
            <div className='box-date'>
              <i className='fa-regular fa-calendar-minus'></i>
              <span>{formattedStartDate}</span>
            </div>
          </div>
          <div className='col-4 col-lg-6 m-auto'>
            <LanguageFilter />
          </div>
          <div className='col-4 col-lg-3'>
            <div className='box-date'>
              <span>{formattedEndDate}</span>
              <i className='fa-regular fa-calendar-minus'></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StudyPeriodDate
